<template>
	<div class="text">
		<div style="text-align:center;font-size:12px;color:#666666;">本版更新时间：2023年1月5日</div>
		<div style="text-align:center;font-size:12px;color:#666666;">本版生效时间：2023年1月5日</div>
		<p>消防设施操作员实操仿真学习软件深知个人信息（含个人敏感信息）对你的重要性，并会尽力保护你的个人信息安全。我们致力于维持你对我们的信任，恪守以下原则，保护你的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、公开透明原则、确保安全原则、主体参与原则等。同时，消防设施操作员实操仿真学习软件承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护你的个人信息。
		本隐私政策（以下简称“本政策”）适用于消防设施操作员实操仿真学习软件的所有相关服务。在使用消防设施操作员实操仿真学习软件各项服务前，请你务必仔细阅读并透彻理解本政策，并做出你认为适当的选择。一旦你开始使用消防设施操作员实操仿真学习软件的各项服务，即表示你已充分理解并同意本政策。需要提醒你注意，本隐私政策仅适用于我们所收集的信息，不适用于通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息以及通过在我们服务中进行广告服务的其他公司或机构所收集的信息。
		本政策将帮助你了解以下内容：</p>
		<p>1、我们如何收集和使用你的个人信息</p>
		<p>2、我们如何使用Cookie 和同类技术</p>
		<p>3、我们如何共享、转让、公开披露你的个人信息</p>
		<p>4、我们如何保护你的个人信息</p>
		<p>5、你的权利</p>
		<p>6、关于儿童的个人信息</p>
		<p>7、你的个人信息如何在全球范围转移</p>
		<p>8、本政策如何更新</p>
		<p>9、如何联系</p>
		<p>10、第三方SDK目录</p>
		<p>相关术语及定义</p>
		<p>1、消防设施操作员实操仿真学习软件：指消防设施操作员实操仿真学习软件APP或对消防设施操作员实操仿真学习软件APP享有所有权或运营权的主体上海爻塔科技有限公司及其关联公司。</p>
		<p class="special">2、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人基本资料（姓名、出生日期）、个人身份信息（身份证、军官证、护照、工作证）、个人生物识别信息（个人基因、指纹）、网络身份标识信息（系统账号、IP地址、邮箱地址及前述有关的密码、口令、口令保护答案）、个人健康生理信息、个人教育工作信息（个人职业、职位、工作单位、学历、学位、教育经历）、个人财产信息（银行账号、存款信息、交易和消费记录、财产信息、征信信息）、个人通信信息（通信通讯联系方式、通信记录和内容）、联系人信息（通讯录、好友列表、群列表）、个人上网记录（指通过日志存储的用户操作记录）、个人常用设备记录（包括硬件序列号、设备MAC地址、软件列表、唯一设备识别码）、个人位置信息（包括行踪轨迹、精准定位信息、住宿信息等）其他信息（婚史、宗教信息、性取向、未公开的违法犯罪记录等）。本定义出自于GB/T35273《信息安全技术个人信息安全规范》。</p>
		<p class="special">3、个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括个人财产信息（银行账号、鉴别信息、交易和消费记录、流水记录等）、个人生物识别信息、个人身份信息（如身份证、军官证、护照、工作证）、网络身份标识信息（如系统账号、邮箱地址及前述有关的密码、口令、口令保护答案）、其他信息（个人电话号码、性取向、婚史、行踪轨迹、网页浏览记录、精确定位信息）等，我们将在本隐私政策中对全部个人敏感信息加粗斜体处理。本定义出自于GB/T35273《信息安全技术个人信息安全规范》。</p>
		<p class="special">4、收集：指获得对个人信息的控制权的行为，包括由个人信息主体主动提供、通过与个人信息主体交互或记录个人信息主体行为等自动采集，以及通过共享、转让、搜集公开信息间接获取等方式。</p>
		<p>5、删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
		<p>6、公开披露：指向社会或不特定人群发布信息的行为。</p>
		<p>7、转让：指将个人信息控制权由一个控制者向另一个控制者转移的过程。</p>
		<p>8、共享：指个人信息控制者向其他控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。</p>
		<p>9、匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能 被复原的过程。 注：个人信息经匿名化处理后所得的信息不属于个人信息。</p>
		<p>10、去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</p>
		<p>11、关联公司：指相互之间存在关联关系的公司，关联关系是指公司控股股东、实际控制人、董事、监事、高级管理人员与其直接或者间接控制的企业之间的关系，以及可能导致公司利益转移的其他关系。</p>
		<p class="head">一、我们如何收集和使用你的个人信息</p>
		<p>1.1 我们如何收集你的个人信息</p>
		<p>你在使用消防设施操作员实操仿真学习软件提供的服务时，为了更好地实现你的目的，我们可能收集和使用你的个人信息。包括：</p>
		<p class="special">1.1.1 你在注册消防设施操作员实操仿真学习软件账号时提供的信息</p>
		<p class="special">注册并登录消防设施操作员实操仿真学习软件账号时，需要你提供手机号码、电子邮箱或第三方账号（微信、QQ、微博、APPLE、抖音等）的信息，我们将通过发送短信验证码或邮件的方式来验证你的账号是否有效。你可根据自身需求补充填写个人信息（头像、昵称、简介、性别、城市、生日等其他个人信息）。</p>
		<p class="special">1.1.2 在你使用服务的过程中收集的信息</p>
		<p class="special">使用本隐私政策“1.2 我们如何使用你的个人信息”中所列举的消防设施操作员实操仿真学习软件产品与/或服务时，我们可能会收集你使用的设备信息（包括操作系统、软件版本、语言设置），浏览信息（包括搜索关键词、访问页面链接和访问时间）。</p>
		<p class="special">1.1.3 为了方便您使用本软件中的邀请功能，需要读取系统的剪切板来检查是否有匹配的邀请码内容。</p>
		<p class="special">1.1.4 设备或软件信息，包括但不限于IMEI、IMSI、设备MAC地址、软件列表、设备序列号、androidID、登录IP地址、已安装APP信息、通讯录、短信等，目的是在我们提供服务时，用于身份验证、客户服务、安全防范、存档和备份用途，确保我们向你您提供的产品和服务的安全性。其中，我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/androidID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
		<p class="special">1.1.5 存储位置和访问权限：应用程序将存储和处理数据的方式符合Android隐私政策，并且只在获得用户明确授权的情况下访问和修改数据。</p>
		<p class="special">1.1.6 剪切板权限：应用程序提供复制官方地址功能，并且只在获得用户明确授权的情况下访问和修改数据,我们重视您的隐私，确保不会滥用或不当处理您的剪切板数据,读取的剪切板内容会在完成相关操作后立即销毁，不会存储在本地或服务器上。</p>
		<p class="special">1.1.7 第三方向消防实操模拟软件提供的信息：</p>
		<p>你在第三方服务中使用消防设施操作员实操仿真学习软件的时候，我们会收集第三方服务向我们提供的有关信息。</p>
		<p class="special">你提供的上述信息，将在你使用本服务期间持续授权我们使用。在你注销账号时，我们将停止使用并删除上述信息。</p>
		<p class="special">上述信息将存储于中华人民共和国境内，不会进行跨境传输。</p>
		<p class="special">提供上述信息，尤其是个人敏感信息，你可能面临用户信息泄露或用户账号被盗、个人隐私及财产安全难以保障等风险，但我们将尽最大努力避免上述风险发生。</p>
		<p class="special">如你选择不提供上述信息，你可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
		<p>1.2 我们如何使用你的信息</p>
		<p>我们会在下列情况下使用你的个人信息：</p>
		<p>1.2.1 向你提供你使用的各项服务，并维护、改进这些服务。</p>
		<p class="special">（1） 在我们提供服务时，用于身份验证、客户服务、安全防范、存档和备份用途，确保我们向你您提供的产品和服务的安全性</p>
		<p class="special">（2） 搜索功能：你可以使用对关键字进行查询的服务，我们需要使用网络存储机制和应用数据缓存，收集你设备上的信息并进行本地存储，以提供更便捷的搜索服务。</p>
		<p class="special">（2） 交易功能：当你希望购买商品、线上课程、专栏，或使用需付费的服务时，你需要使用“支付功能”。</p>
		<p class="special">（3） 营销活动：你可以参加由我们或第三方举办的线上或线下的营销活动，包括线下分享会或展览，我们会征得你的同意后，收集你的手机号码、用户id、真实姓名以提供更好的活动体验。</p>
		<p class="special">（4） 客服功能：你可以向客服发起投诉、申诉或咨询，我们需要你提供真实姓名、手机号码、电子邮件。以及时地向你反馈投诉、申诉或咨询结果，如以个人名义进行投诉，还需要提供身份证件。</p>
		<p class="special">（5） 客服功能：你可以向客服发起投诉、申诉或咨询，我们需要你提供真实姓名、手机号码、电子邮件。以及时地向你反馈投诉、申诉或咨询结果，如以个人名义进行投诉，还需要提供身份证件。</p>
		<p class="special">（6） 存储功能：我们会在用户同意隐私协议后，记录在App本地，下次再进来不在提示用户同意隐私协议,保存图片到本地，方便用户本地查看。</p>
		<p class="special">（7） 剪切板功能：我们会在用户同意隐私协议后，允许复制功能，方便用户复制地址。</p>
		<p>1.2.2 需要提醒你注意，以下情形中，使用你的个人信息无需你的同意：</p>
		<p>（1）与国家安全、国防安全直接相关的。</p>
		<p>（2）与公共安全、公共卫生、重大公共利益直接相关的。</p>
		<p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
		<p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。</p>
		<p>（5）所收集的个人信息是你自行向社会公众公开的。</p>
		<p>（6）从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
		<p>（7）根据你的要求签订和履行合同所必需的。</p>
		<p>（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</p>
		<p>（9）出于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</p>
		<p>（10）法律法规规定的其他情形。</p>
			<p class="head">二、我们如何使用同类技术</p>
		<p>2.1 网站信标和像素标签</p>
		<p>我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向你发送的电子邮件可能含有链接至我们网站内容的点击URL。如果你点击该链接，我们则会跟踪此次点击，帮助我们了解你的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果你不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订，如你未办理退订手续的，则视为你同意我们采取的网站信标和像素标签措施和服务。</p>
		<p>2.3 Do Not Track(请勿追踪)</p>
		<p>很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果你的浏览器启用了 Do NotTrack，那么我们的网站都会尊重你的选择。</p>
			<p class="head">三、我们如何共享、转让、公开披露你的个人信息</p>
		<p>我们充分知晓因违法共享、转让、公开披露个人信息对个人信息主体造成损害时所应承担的法律责任，对于你的个人信息的一切共享、转让、公开披露，我们将严格按照以下条款进行：</p>
		<p>3.1 共享</p>
		<p>尊重用户个人隐私是消防设施操作员实操仿真学习软件的一项基本原则。除以下情形外，我们不会与任何公司、组织和个人分享你的个人信息：</p>
		<p  class="special">3.1.1 在获取明确同意的情况下共享：获得你的明确同意后，我们会与其他方共享你的个人信息。</p>
		<p  class="special">3.1.2 我们可能会按照司法机关或行政机关的要求，对外共享你的个人信息。</p>
		<p  class="special">3.1.3 与我们的关联公司共享：你的个人信息可能会与消防设施操作员实操仿真学习软件的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求你的授权同意。</p>
		<p  class="special">3.1.4</p>
		<p  class="special">与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享你的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享你的个人信息，并且只会共享提供服务所必要的个人信息，例如在你上网购买我们的产品时必须与物流公司共享你的信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>
		<p  class="special">3.1.5 合作的第三方SDK服务商：当你使用APP中由第三方提供的功能时，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关功能。具体包括如下： </p>
		<p>A.第三方账号登录功能：为给你提供第三方账号绑定的功能，第三方服务商ShareSDK可能会获取你的必要设备信息、网络相关信息； </p>
		<p>B.地理位置服务：为给你提供位置服务，第三方地理位置服务商高德SDK会收集你的设备信息及地理位置信息以便可以向你推送附近地点的服务； </p>
		<p>C.消息推送：为给你提供及时的消息推送，第三方推送服务商小米推送SDK可能会获取你必要设备信息、手机状态信息、地理位置信息、网络相关信息等。</p>
		<p>D.数据统计功能：我们会使用友盟SDK以准确记录App的活跃情况、设备信息、网络相关信息。 </p>
		<p>E.其它功能：为给你提供便捷的分享功能我们会使用微信SDK、QQSDK，相关功能可能会获取你的设备信息和网络相关信息。</p>
		<p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
		<p>3.2 转让</p>
		<p>我们不会将你的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
		<p>3.2.1 在获取明确同意的情况下转让：获得你的明确同意后，我们会向其他方转让你的个人信息。</p>
		<p>3.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有你个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向你征求授权同意。</p>
		<p>3.3 公开披露</p>
		<p>我们仅会在以下情况下，公开披露你的个人信息：</p>
		<p>3.3.1 获得你明确同意后。</p>
		<p>3.3.2 基于司法机关或行政机关的要求，我们可能会公开披露你的个人信息。</p>
			<p class="head">四、我们如何保护你的个人信息</p>
		<p>4.1 保护措施</p>
		<p>4.1.1 我们已使用符合业界标准的安全防护措施保护你提供的个人信息， 防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护你的个人信息。例如，在你的浏览器与“服务”之间交换数据(如信用卡信息)时受SSL加密保护；我们同时对消防设施操作员实操仿真学习软件网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
		<p>4.1.2 我们会采取一切合理可行的措施，确保未收集无关的个人信息。除非取得你的书面许可，我们将在且仅在你删除或注销账户后36个月保留你的个人信息， 超出此期限后，我们将会对你的个人信息进行匿名化处理或销毁。</p>
		<p>4.1.3 互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他消防设施操作员实操仿真学习软件用户的交流方式并未加密，我们强烈建议你不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证你的账号安全。</p>
		<p>4.1.4互联网环境并非百分之百安全，我们将尽力确保或担保你发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致你的合法权益受损，我们将承担相应的法律责任。</p>
		<p>4.1.5在不幸发生个人信息安全事件后，我们将按照《网络安全法》第42条第二款之规定及时向你告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知你，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
			<p class="head">五、你的权利</p>
		<p>无论你何时使用消防设施操作员实操仿真学习软件，我们都会尽一切可能保证你可以顺利访问自己的账户信息。如果这些信息有误，我们会努力提供各种方式来让你快速更新或删除账户内信息。为了使你拥有充分的能力保障你的隐私和安全，你拥有如下权利：</p>
		<p>5.1 访问你的个人信息</p>
		<p>除司法机关或行政机关另有要求外，你有权随时访问你的个人信息。包括以下信息：</p>
		<p>账户信息：</p>
		<p>如果你希望访问或编辑你的账户中的名号/昵称、域名、头像、登录邮箱、手机号、隐私设置等，可以通过播种网或消防设施操作员实操仿真学习软件应用程序内个人设置执行此类操作。</p>
		<p>搜索信息：</p>
		<p>你可以在搜索时，访问或使用清除功能，清除你的搜索历史记录。</p>
		<p>如果你无法通过上述链接及方式访问，你可以随时联系我们，我们将尽快回复你的请求。</p>
		<p>5.2 更正你的个人信息</p>
		<p>当你发现你所填写的或者我们处理的关于你的个人信息有错误时，你有权自行更正。当你无法自行更正时，你可以随时联系我们，我们将尽快回复你的更正请求。</p>
		<p>5.3 删除你的个人信息</p>
		<p>你有权随时自行删除或者联系我们删除你的个人信息。在以下情形中，你可以向我们提出删除个人信息的请求：</p>
		<p>5.3.1 我们处理个人信息的行为违反法律法规的。</p>
		<p>5.3.2 我们收集、使用你的个人信息，却未征得你的同意。</p>
		<p>5.3.3 我们处理个人信息的行为违反了与你的约定。</p>
		<p>5.3.4 你不再使用我们的产品或服务，或你注销了账号。</p>
		<p>5.3.5 我们不再为你提供产品或服务。</p>
		<p>若我们决定响应你的删除请求，我们还将同时通知从我们获得你的个人信息的实体，要求其及时删除，除非这些实体另行获得你的独立授权。</p>
		<p>当你从我们的服务中删除你的个人信息后，我们也会从备份系统中删除相应的信息。</p>
		<p>如因经营不善等原因，我们停止运营了，我们会立即停止对你对应个人信息的收集，并删除已收集的个人信息。</p>
		<p>5.4 改变你授权同意的范围或撤回你的授权</p>
		<p>每个业务功能需要一些基本的个人信息才能得以完成(见本政策“第一部分”)。对于额外收集的个人信息的收集和使用，你可以随时给予或收回你的授权同意。</p>
		<p>你可以通过删除信息、关闭移动设备功能、在消防设施操作员实操仿真学习软件应用程序中进行隐私设置等方式改变你授权同意的范围或撤回你的授权。</p>
		<p>当你收回同意后，我们将不再处理相应的个人信息。但你收回同意的决定，不会影响此前基于你的授权而开展的个人信息处理。</p>
		<p>5.5 注销／删除账号</p>
		<p>你可以选择注销／删除消防设施操作员实操仿真学习软件账号，账号被注销／删除后将不可恢复，你的个人信息将被删除或匿名化处理，建议你做好备份。注销／删除后手机号可自动解除绑定，之后可以与其它消防设施操作员实操仿真学习软件账号绑定。</p>
		<p>如果你确定要注销账号，可以按通过客服申请注销账号。</p>
		<p>5.6 获取你的个人信息副本</p>
		<p>我们将根据你的书面请求，为你提供以下类型的个人信息副本：你的个人基本资料、个人身份信息。但请注意，我们为你提供的信息副本仅以我们收集的信息为限。</p>
		<p>5.7 约束信息系统自动决策</p>
		<p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响你的合法权益，你有权要求我们做出解释，我们也将提供适当的救济方式。</p>
		<p>5.8 响应你的上述请求</p>
		<p>为保障安全，你可能需要提供书面请求，或以其他方式证明你的身份。我们可能会先要求你验证自己的身份，然后再处理你的请求。</p>
		<p>我们将在十五天内做出答复。如你不满意，还可以通过邮件、电话、应用程序内反馈途径投诉。</p>
		<p>对于你合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际(例如，涉及备份磁带上存放的信息)的请求，我们可能会予以拒绝。</p>
		<p>在以下情形中，按照法律法规要求，我们将无法响应你的请求：</p>
		<p>5.8.1 与国家安全、国防安全直接相关的。</p>
		<p>5.8.2 与公共安全、公共卫生、重大公共利益直接相关的。</p>
		<p>5.8.3 与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
		<p>5.8.4 有充分证据表明你存在主观恶意或滥用权利的。</p>
		<p>5.8.5 响应你的请求将导致你或其他个人、组织的合法权益受到严重损害的。</p>
		<p>5.8.6 涉及商业秘密的。</p>
			<p class="head">六、关于儿童的个人信息</p>
		<p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。对于经父母同意而收集未成年个人信息的情况，我们只会在司法机关或行政机关要求、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对未成年人的定义不同，但我们将不满 16 周岁的任何人均视为未成年人。 如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
			<p class="head">七、你的个人信息如何在全球范围转移</p>
		<p>我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，不会存在个人信息出境之情况。</p>
			<p class="head">八、本政策如何更新</p>
		<p>我们的隐私政策将不定时更新。</p>
		<p>通常情况下，我们不会明显削减你按照本隐私政策所应享有的权利。我们会在本页面上发布更新后的版本并且以弹框或与弹框同等显著的方式通知你本政策所做的任何变更，你同意后，即表示同意接受受经修订的本政策的约束。</p>
			<p class="head">九、如何联系我们</p>
		<p>如果你对本隐私政策有任何疑问、意见或建议，可以通过邮箱：yaotakeji2022#126.com 与我们联系(#换成@)。</p>
		<p>如果你对我们的回复不满意，特别是我们的个人信息处理行为损害了你的合法权益，你还可以通过向消防设施操作员实操仿真学习软件所在地有管辖权的人民法院提起诉讼的方式寻求解决方案。</p>
			<p class="head">十、第三方SDK目录</p>
		<p>为保障本应用功能实现和安全支行，我们会接入第三方SDK。</p>
		<p>10.1</p>
		<p>SDK名称：com.alipay(支付宝;)</p>
		<p>使用目的：实现应用中的支付宝支付功能</p>
		<p>使用方式：在支付功能中调用</p>
		<p>第三方官网链接：https://opendocs.alipay.com/open/54</p>
		<p>10.2</p>
		<p>SDK名称：微信开放sdk(微信分享、登录、收藏、支付等功能)</p>
		<p>使用目的：实现应用中的微信支付、分享功能</p>
		<p>使用方式：在支付功能、分享功能中调用</p>
		<p>第三方官网链接：https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '隐私政策'
		}
	}
</script>

<style scoped>
p{
	text-align: left;
	font-weight: 400;
}
.text{
padding: 15px;
font-size: 14px;
color: #333;
}
.text p{
line-height: 1.6;
font-family:Arial, Helvetica, sans-serif
}
.text .head {
font-weight: 500;
}
.text .space2 {
text-indent: 2em;
}
.text .space4 {
text-indent: 4em;
}
.special{
	font-weight: bold;
}
</style>
